import React from 'react';
import Panel from '../../components/design/Panel';
import Badge from '../../components/design/Badge';
import { formatTime } from '../../utils/formatTime';

function statusOf(s) {
  if (s.open_count > 0) return { tone: s.open_count > 50 ? 'red' : 'amber', label: 'Alerting' };
  if (s.last_24h > 0) return { tone: 'green', label: 'Active' };
  return { tone: 'gray', label: 'Idle' };
}

export default function DashboardSources({ sources }) {
  const rows = sources || [];
  return (
    <Panel title="Source Status" sub="Detection sources by activity" noPad>
      {rows.length === 0 ? (
        <div className="empty">No sources</div>
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr><th>Source</th><th>Open</th><th>24h</th><th>Last seen</th><th>Status</th></tr>
            </thead>
            <tbody>
              {rows.map(s => {
                const st = statusOf(s);
                return (
                  <tr key={s.source}>
                    <td><span style={{ color: 'var(--text-1)', fontWeight: 500 }}>{s.source}</span></td>
                    <td><span className="mono">{s.open_count}</span></td>
                    <td><span className="mono">{s.last_24h}</span></td>
                    <td><span className="mono muted">{s.last_seen ? formatTime(s.last_seen) : '—'}</span></td>
                    <td><Badge tone={st.tone}>{st.label}</Badge></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </Panel>
  );
}
